const theme = {
  colors: {
    // Dark base colors for glassy effect
    primaryDark: '#0a0a0f', // Deep dark blue-black
    primary: '#1a1a2e', // Dark navy
    secondary: '#16213e', // Slightly lighter navy
    
    // Vibrant neon accents
    neonBlue: '#00d4ff', // Electric blue
    neonMagenta: '#ff0080', // Vibrant magenta
    neonGreen: '#00ff88', // Emerald green
    neonPurple: '#8b5cf6', // Electric purple
    neonYellow: '#ffff00', // Electric yellow
    
    // Glass and transparency colors
    glassWhite: 'rgba(255, 255, 255, 0.1)',
    glassDark: 'rgba(0, 0, 0, 0.2)',
    glassBlur: 'rgba(255, 255, 255, 0.05)',
    
    // Soft secondary colors
    softBlue: '#e0f2fe',
    softPink: '#fce7f3',
    softGreen: '#ecfdf5',
    softPurple: '#f3e8ff',
    
    // Text colors
    textPrimary: '#ffffff',
    textSecondary: 'rgba(255, 255, 255, 0.8)',
    textMuted: 'rgba(255, 255, 255, 0.6)',
    textDark: '#1a1a2e',
    
    // Status colors with neon variants
    success: '#00ff88',
    warning: '#ffff00',
    error: '#ff0080',
    info: '#00d4ff',
  },
  
  gradients: {
    // Primary glass gradients
    glassCard: 'linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%)',
    glassHover: 'linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0.08) 100%)',
    
    // Neon gradients
    neonBlue: 'linear-gradient(135deg, #00d4ff 0%, #0099cc 100%)',
    neonMagenta: 'linear-gradient(135deg, #ff0080 0%, #cc0066 100%)',
    neonGreen: 'linear-gradient(135deg, #00ff88 0%, #00cc66 100%)',
    neonPurple: 'linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)',
    
    // Background gradients
    primaryBg: 'linear-gradient(135deg, #0a0a0f 0%, #1a1a2e 50%, #16213e 100%)',
    heroBg: 'radial-gradient(ellipse at top, rgba(0, 212, 255, 0.1) 0%, rgba(26, 26, 46, 0.8) 50%, rgba(10, 10, 15, 1) 100%)',
    
    // Soft gradients for cards
    softCard: 'linear-gradient(135deg, rgba(255, 255, 255, 0.02) 0%, rgba(255, 255, 255, 0.01) 100%)',
  },
  
  fonts: {
    heading: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    body: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
    code: "'JetBrains Mono', 'Fira Code', monospace",
  },
  
  breakpoints: {
    xs: '480px',
    sm: '640px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
    xxl: '1536px',
  },
  
  shadows: {
    glass: '0 8px 32px rgba(0, 0, 0, 0.3)',
    glassHover: '0 12px 40px rgba(0, 0, 0, 0.4)',
    neon: '0 0 20px rgba(0, 212, 255, 0.3)',
    neonHover: '0 0 30px rgba(0, 212, 255, 0.5)',
    inner: 'inset 0 1px 0 rgba(255, 255, 255, 0.1)',
  },
  
  blur: {
    sm: '4px',
    md: '8px',
    lg: '12px',
    xl: '16px',
  },
  
  animations: {
    easeOutCubic: 'cubic-bezier(0.33, 1, 0.68, 1)',
    easeInOutCubic: 'cubic-bezier(0.65, 0, 0.35, 1)',
    bounce: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  },
  
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '2rem',
    xl: '3rem',
    xxl: '5rem',
    xxxl: '8rem',
  },
};

export default theme;